module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('detail-page-layout', {
    attrs: {
      "config": _vm.pageConfig
    }
  }, [_c('div', {
    staticClass: "title-h3-text2"
  }, [_vm._v("当前余额："), _c('span', [_vm._v(_vm._s(_vm._f("amount")(_vm.Balance)))]), _vm._v(" 元")]), _vm._v(" "), _c('el-row', {
    staticClass: "title-border"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "CreateOn",
      "label": "充值时间"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("date")(scope.row.CreateOn, 'YYYY-MM-DD HH:mm:ss')))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Code",
      "label": "流水号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Type",
      "label": "类型"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Amount",
      "label": "充值金额"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.Amount > 0) ? _c('span', {
          staticClass: "status"
        }, [_vm._v(_vm._s(_vm._f("amount")(scope.row.Amount)))]) : _vm._e(), _vm._v(" "), (scope.row.Amount < 0) ? _c('span', {
          staticClass: "green"
        }, [_vm._v(_vm._s(_vm._f("amount")(scope.row.Amount)))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Remark",
      "label": "说明"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c8b3506"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Financial/DepositDetail.vue
// module id = 723
// module chunks = 0